import image from '../../img/layouts/layout-preview-vertical-video.png';

export const preview = {
  image,
  description: 'Vertical Video',
};
